import { createSelector } from 'reselect';
export const getModals = state => state.modals;
export const getModal = createSelector([getModals], modals => modals.modal);